// Polyfills
import "lazysizes";

// Libs
import Vue from "vue";
import Headroom from "headroom.js";

// Modules
import "./modules/menu";
import "./modules/sidebars";
import "./modules/sticky-detector";
import "./modules/forms";
import "./modules/popover";

if (document.getElementById("cluster-logos")) {
    Vue.component(
        "cluster-logos",
        require("./components/ClusterLogos.vue").default
    );

    let vue = new Vue({
        el: "#cluster-logos",
    });
}

let navbar = document.querySelector(".navbar");

let options = {
    classes: {
        // when element is initialised
        initial: "navbar",
        // when scrolling up
        pinned: "navbar--pinned",
        // when scrolling down
        unpinned: "navbar--unpinned",
    },
};
// construct an instance of Headroom, passing the element
let headroom = new Headroom(navbar, options);

// Only init if mobile device
if (
    typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("IEMobile") !== -1
) {
    headroom.init();
}

// Application files
